import * as types from './types'
import { toast } from 'react-toastify'
import moment from 'moment'
import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import history from '../utils/history'
import { displayMessages, uploadFiles } from './common'


export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_TIQUETESAEREO })
	}
}


export function updateInputs(path, value) {
	return (dispatch) => {

        if(path === 'motivo_viaje' || path === 'observaciones' || path.includes('celular') || path.includes('cedula') || path.includes('nombres') || path.includes('apellidos') || path.includes('nacionalidad') || path.includes('pais_expedicion')){
            const regex = /[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;
            value = value.replace(regex, "").toUpperCase();
        }

		dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO, payload: { path, value } })
	}
}



export function addTrayecto() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_TRAYECTO })
	}
}


export function removeTrayectos() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_TRAYECTOS })
	}
}



export function validateCaducidadPasaporte(value) {
	return (dispatch) => {
		if (moment(value) < moment(new Date()) ) {
			displayMessages(dispatch, { warning: 'La fecha de caducidad del pasaporte es inferior o igual a la fecha actual' })
		}
	}
}



export function createTiqueteAereo() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const formData = new FormData()
		let index;

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO, payload: false })
		const fn2 = (d) => d(initReducer())

		fn0(dispatch)

		const data = getState().creaciontiqueteaereo
        const files = data.get('adjuntos')

		index = 1;
        data.get('foros').map((f) => {
			f.get('solicitud_id') && formData.append(`foros[${index}][solicitud_id]`, f.get('solicitud_id'))
			f.get('usuario_id') && formData.append(`foros[${index}][usuario_id]`, f.get('usuario_id'))
			f.get('comentario') && formData.append(`foros[${index}][comentario]`, f.get('comentario'))

            index++
		})

		data.get('motivo_viaje') && formData.append('motivo_viaje', data.get('motivo_viaje'))
		data.get('fecha_solicitud') && formData.append('fecha_solicitud', data.get('fecha_solicitud'))
		data.get('tipo_viaje') && formData.append('tipo_viaje', data.get('tipo_viaje'))
		formData.append('asistencia_viajero', Number(data.get('asistencia_viajero')))
		data.get('tipo_trayecto') && formData.append('tipo_trayecto', data.get('tipo_trayecto'))
		data.get('cant_pasajeros') && formData.append('cant_pasajeros', data.get('cant_pasajeros'))
		data.get('tiquete_comprado') && formData.append('tiquete_comprado', data.get('tiquete_comprado'))
		data.get('observaciones') && formData.append('observaciones', data.get('observaciones'))

		index = 1;
        data.get('trayectos').map((t) => {
			t.get('origen') && formData.append(`trayectos[${index}][origen]`, t.get('origen'))
			t.get('aeropuerto_origen') && formData.append(`trayectos[${index}][aeropuerto_origen]`, t.get('aeropuerto_origen'))
			t.get('fecha_ida') && formData.append(`trayectos[${index}][fecha_ida]`, `${t.get('fecha_ida')} ${t.get('hora_ida')}`)
			t.get('destino') && formData.append(`trayectos[${index}][destino]`, t.get('destino'))
			t.get('aeropuerto_destino') && formData.append(`trayectos[${index}][aeropuerto_destino]`, t.get('aeropuerto_destino'))
			t.get('fecha_regreso') && formData.append(`trayectos[${index}][fecha_regreso]`, `${t.get('fecha_regreso')} ${t.get('hora_regreso')}`)
            index++
		})

		index = 1;
        data.get('cencos').map((c) => {
			c.get('porcentaje') && formData.append(`cencos[${index}][porcentaje]`, c.get('porcentaje'))
			c.getIn(['cenco', 'id']) && formData.append(`cencos[${index}][id]`, c.getIn(['cenco', 'id']))
            index++
		})



		index = 1;
        data.get('pasajeros').map((p) => {

			formData.append(`pasajeros[${index}][tipo_pasajero]`, p.get('tipo_pasajero'))
			formData.append(`pasajeros[${index}][nombres]`, p.get('nombres'))
			formData.append(`pasajeros[${index}][apellidos]`, p.get('apellidos'))
			formData.append(`pasajeros[${index}][cedula]`, p.get('cedula'))
			formData.append(`pasajeros[${index}][correo]`, p.get('correo'))
			formData.append(`pasajeros[${index}][fecha_nacimiento]`, p.get('fecha_nacimiento'))
			formData.append(`pasajeros[${index}][celular]`, p.get('celular'))
			formData.append(`pasajeros[${index}][tipo_documento]`, p.get('tipo_documento'))

			if (data.get('tipo_viaje') == 2) {
				formData.append(`pasajeros[${index}][pasaporte]`, p.get('pasaporte'))
				formData.append(`pasajeros[${index}][nacionalidad]`, p.get('nacionalidad'))
				formData.append(`pasajeros[${index}][pais_expedicion]`, p.get('pais_expedicion'))
				formData.append(`pasajeros[${index}][fecha_caducidad_pasaporte]`, p.get('fecha_caducidad_pasaporte'))
				p.getIn(['pasaporte_adjunto', 'clasificacion']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][clasificacion]`, p.getIn(['pasaporte_adjunto', 'clasificacion']))
				p.getIn(['pasaporte_adjunto', 'file']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][file]`, p.getIn(['pasaporte_adjunto', 'file']), p.getIn(['pasaporte_adjunto', 'file']).name)
				p.getIn(['pasaporte_adjunto', 'guid']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][guid]`, p.getIn(['pasaporte_adjunto', 'guid']))
				p.getIn(['pasaporte_adjunto', 'icono']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][icono]`, p.getIn(['pasaporte_adjunto', 'icono']))
				p.getIn(['pasaporte_adjunto', 'nombre']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][nombre]`, p.getIn(['pasaporte_adjunto', 'nombre']))
				p.getIn(['pasaporte_adjunto', 'observaciones']) && formData.append(`pasajeros[${index}][pasaporte_adjunto][observaciones]`, p.getIn(['pasaporte_adjunto', 'observaciones']))


				if (data.get('asistencia_viajero')) {

					// const fecha_salida = data.get('trayectos').first().get('fecha_ida')
					// let fecha_regreso
					// if (data.get('tipo_trayecto') == 1) {
					// 	fecha_regreso = data.get('trayectos').last().get('fecha_regreso')
					// } else {
					// 	fecha_regreso = p.getIn(['asistencia', 'fecha_regreso'])
					// }


					formData.append(`pasajeros[${index}][asistencia][guid]`, p.getIn(['asistencia', 'guid']))
					formData.append(`pasajeros[${index}][asistencia][pais_destino]`, p.getIn(['asistencia', 'pais_destino']))
					formData.append(`pasajeros[${index}][asistencia][fecha_salida]`, p.getIn(['asistencia', 'fecha_salida']))
					formData.append(`pasajeros[${index}][asistencia][fecha_regreso]`, p.getIn(['asistencia', 'fecha_regreso']))
					formData.append(`pasajeros[${index}][asistencia][avisar_a]`, p.getIn(['asistencia', 'avisar_a']))
					formData.append(`pasajeros[${index}][asistencia][direccion]`, p.getIn(['asistencia', 'direccion']))
					formData.append(`pasajeros[${index}][asistencia][ciudad]`, p.getIn(['asistencia', 'ciudad']))
					formData.append(`pasajeros[${index}][asistencia][celular]`, p.getIn(['asistencia', 'celular']))
					formData.append(`pasajeros[${index}][asistencia][telefono]`, p.getIn(['asistencia', 'telefono']))

				}

			}

			index++

        })




		axios.post(`${API_URL}/solicitudes/tiquetes-aereos`, formData)
		.then(res => {
			const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas');
			const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
            dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3, fn4]))
			fn1(dispatch);
			fn2(dispatch);
			fn3();
			fn4();


		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn1(dispatch)
		})
	}
}



export function addFile() {
	return (dispatch, getState) => {

		const data = getState().common.getIn(['modalAddFile', 'data'])
		const index = getState().common.getIn(['modalAddFile', 'index'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {



			const fn1 = (d) => d({ type: types.ADICIONAR_PASAPORTE, payload: {index, data} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })

            const path = "flagAdjunto";
            const value = false;

            const fn3 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO, payload: { path, value } })
            fn1(dispatch)
			fn2(dispatch)
            fn3(dispatch)
		}
	}
}

export function addPasajero(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
		const pasajeros = getState().creaciontiqueteaereo.get(path)
		if (pasajeros.filter(x => x.get('id') === payload.value.id).count() !== 0) {
			toast.warn(`La persona ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let pasajero = getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS()
			pasajero = {...pasajero, ...payload.value}
			pasajero.correo = pasajero.email
			pasajero.cedula = pasajero.username
			payload.value = pasajero
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO, payload })
		}
	}
}



export function addOrigen(payload, query) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
		const trayectos = getState().creaciontiqueteaereo.get(path) //trayectos.0.origen

		if (trayectos.filter(x => x.get('origen') === payload.value.code).count() !== 0) {
			toast.warn(`La ubicacion ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let trayecto = getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS()
			trayecto.origen = payload.value.code
			trayecto.aeropuerto_origen = payload.value.name + ' ' + query.toUpperCase()
			payload.value = trayecto
			payload.value = trayecto
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO, payload })
		}
	}
}


export function addDestino(payload, query) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
		const trayectos = getState().creaciontiqueteaereo.get(path)

		if (trayectos.filter(x => x.get('destino') === payload.value.code).count() !== 0) {
			toast.warn(`La ubicacion ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let trayecto = getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS()
			trayecto.destino = payload.value.code
			trayecto.aeropuerto_destino = payload.value.name + ' ' + query.toUpperCase()
			payload.value = trayecto
			payload.value = trayecto
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO, payload })
		}
	}
}



export function addCencoSolicitud() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO })
	}
}


export function removeCenco() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_CENCOS_TIQUETESAEREOS })
	}
}


export function enviarComentario() {
	return (dispatch, getState) => {
		const guid = getState().creaciontiqueteaereo.getIn(['comentario', 'guid'])
		const comentario = getState().creaciontiqueteaereo.getIn(['comentario', 'texto'])
		const usuario = getState().common.get('user')
		const fn1 = (d) => d({ type: types.ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO, payload: {comentario, guid , usuario} })
		fn1(dispatch)
	}
}

export function editarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO, payload: {guid} })
		fn1(dispatch)
	}
}

export function eliminarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO, payload: { guid } })
		fn1(dispatch)
	}
}

export function addFileAdjunto(){
    return (dispatch, getState) => {
        const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1, payload: data })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function removeSolicitudTiqutesAereos() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO })
	}
}











// WEBPACK FOOTER //
// ./src/actions/creaciontiqueteaereo.js